import * as ActionTypes from '../constants';
import { baseUrl } from '.';
import axios from 'axios';
import { getUserToken } from './getUserToken';

const dispatchRequestAppTermsAndConditions = () => ({
    type: ActionTypes.REQUEST_APP_TERMS_AND_CONDITIONS
})

const dispatchReceivedAppTermsAndConditions = res => ({
    type: ActionTypes.RECEIVED_APP_TERMS_AND_CONDITIONS,
    res
})

const dispatchErrorAppTermsAndConditions = err => ({
    type: ActionTypes.ERROR_APP_TERMS_AND_CONDITIONS,
    err
})

const dispatchClearAppTermsAndConditions = () => ({
    type: ActionTypes.CLEAR_APP_TERMS_AND_CONDITIONS
})

export const clearAppTermsAndConditionsData = () => dispatchClearAppTermsAndConditions();


export const getAppTermsAndConditions = appTermsAndConditionsData => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestAppTermsAndConditions());   
            const options = {
                method: 'post',
                url: `${baseUrl}/api/get_app_terms_and_conditions`, 
                data: appTermsAndConditionsData,     
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedAppTermsAndConditions(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorAppTermsAndConditions(e.response)));
}
